import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import VisualitzacioContainerMapa from "./VisualitzacioContainerMapa";
import VisualitzacioContainerTaula from "./VisualitzacioContainerTaula";
import { TAULA } from "../../constantsFormularis";
import { getTipusActiu } from "../../reducers";

class VisualitzacioContainerTaulaMapa extends Component {
  render() {
    const { tipusActiu } = this.props;

    return (
      <div>
        {tipusActiu === TAULA ? (
          <VisualitzacioContainerTaula />
        ) : (
          <VisualitzacioContainerMapa />
        )}
      </div>
    );
  }
}

VisualitzacioContainerTaulaMapa.propTypes = {
  tipusActiu: PropTypes.string
};

const mapStateToProps = state => {
  return {
    tipusActiu: getTipusActiu(state)
  };
};

export default connect(mapStateToProps, {})(VisualitzacioContainerTaulaMapa);
